<template>
  <v-container class="px-0 pb-4">
    <v-divider v-if="!noLine"></v-divider> 
    <v-alert v-if="type==2" dense text type="warning" icon="fa fa-exclamation-triangle" width="100%">
          Não será possível ignorar o erro, corrija o arquivo e o carregue novamente!
    </v-alert>
    <!-- ERROS DE LOTES -->
    <div v-if="listLote && listLote.length > 0">
      <v-data-table dense :headers="headersGuia" :items="listLote" hide-default-footer>
      </v-data-table>
      <v-divider></v-divider>
      </div>
      <!-- ERROS DE GUIAS E/OU  ITENS -->
    <span class="pr-0 pl-0" v-if="listGuia">
      <h1  style="font-size: 18px; color: #D0021B" class="pb-0 pt-5 px-0">Críticas nas Guias</h1>
      <v-row class="ma-0 pt-5" v-for="erroGuia in listGuia" :key="erroGuia.id">
          <v-col class="pa-0" cols="2">
            <b class="texts">Nº guia prestador:</b>
            <p class="texts mb-0">{{erroGuia.numeroGuiaPrestador}}</p>
          </v-col>
          <v-col class="pa-0" cols="2">
            <b class="texts">Nº guia operadora:</b>
            <p class="texts mb-0">{{erroGuia.numeroGuiaOperadora}}</p>
          </v-col>
           <v-col class="pa-0" cols="2">
            <b class="texts">Cart. beneficiário:</b>
            <p class="texts mb-0">{{erroGuia.numeroCarteira}}</p>
          </v-col>
          <v-col class="pa-0" cols="6">
            <b class="texts">Nome beneficiário:</b>
            <p class="texts mb-0">{{erroGuia.nomeBeneficiario}}</p>
          </v-col>
          <v-col class="px-0 py-2" cols="12" v-if="erroGuia.erros">
            <v-data-table dense :headers="headersGuia" :items="erroGuia.erros.erro" hide-default-footer class="px-2 py-0">
            </v-data-table>
          </v-col>
          <v-col class="pa-0 py-0" cols="11" offset="1" v-if="erroGuia.erroItem">
            <h1  style="font-size: 18px; color: #D0021B" class="pb-0 pt-5 px-0">Críticas nos Itens</h1>
            <v-row class="ma-0 pt-5" v-for="item in erroGuia.erroItem" :key="item.id">
              <v-col class="pa-0" cols="2">
                <b class="texts">Código do item:</b>
                <p class="texts mb-0">{{item.codProcedimento}}</p>
              </v-col>
              <v-col class="pa-0" cols="6">
                <b class="texts">Descrição:</b>
                <p class="texts mb-0">{{item.desProcedimento}}</p>
              </v-col>
              <v-col class="pa-0" cols="2">
                <b class="texts">Execução:</b>
                <p class="texts mb-0">{{item.dataExecucao | formatDate}}</p>
              </v-col>
              <v-col class="pa-0" cols="2">
                <b class="texts">Valor:</b>
                <p class="texts mb-0">R$ {{item.valorTotal | formatPrice}}</p>
              </v-col>
              <v-col class="px-0 py-2" cols="12">
                <v-data-table dense :headers="headersGuia" :items="item.erros.erro" hide-default-footer>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="px-0 pb-0 pt-3" cols="12"><v-divider></v-divider></v-col>
      </v-row>
    </span>
    <!-- ERROS DE VALIDAÇÃO  -->
    <div v-if="itemsErro != null" >
      <h1 style="font-size: 18px; color: #D0021B" class="pt-3 pb-2 px-0">Erros na validação</h1>
      <v-data-table dense :headers="headers" :items="itemsErro.Erro ? itemsErro.Erro : itemsErro" :items-per-page="-1" hide-default-footer>
      </v-data-table>
    </div>
    <!-- ERROS DE ENVIO -->
    <div v-if="listEnvio && listEnvio.length > 0">
      <h1 style="font-size: 18px; color: #D0021B" class="pt-3 pb-2 px-0">Erros de envio</h1>
      <v-data-table dense :headers="headersGuia" :items="listEnvio" :items-per-page="-1" hide-default-footer>
          </v-data-table>
          </div>
      
      <v-row class="pb-0 pt-8 px-3" style="height: 20%;">
        <v-spacer v-if="dadosLote.etapa != 99 && dadosLote.env_op_tem_erro != 1 || !envioAutomatico && dadosLote.env_op_tem_erro != 1 || dadosLote.fl_tratado==1 && dadosLote.env_op_tem_erro != 1 || dadosLote.env_op_tem_erro == 1 && dadosLote.etapa == 20"></v-spacer>
        <v-btn
          color="primary"
          height="30px"
          small
          depressed
          outlined
          @click="cleanClose()"
        >
          Fechar
        </v-btn>
        <v-spacer></v-spacer>
        <!--  -->
        <!-- <v-btn v-if="envioAutomatico && dadosLote.env_op_tem_erro == 1 && (dadosLote.fl_tratado != 1 || dadosLote.critica_ignorada != 1) && dadosLote.erro_tipo == 3"
          color="error"
          height="30px"
          small
          depressed
          @click="ReenvioDeLote()"
        >
          Tentar enviar novamente
        </v-btn> -->
          <!-- v-if="dadosLote.etapa == 99 && envioAutomatico && dadosLote.fl_tratado !=1 && type != 2" -->
        <v-btn
          v-if="dadosLote.fl_tratado !=1 && dadosLote.critica_ignorada !=1 && type != 2"
          color="error"
          outlined
          height="30px"
          small
          depressed
          class="ml-4"
          @click="showIgnoraErro=true"
        >
        <!-- @click="setFlagTratadoConfirm()" -->
          Ignorar erros manualmente
        </v-btn>
        <v-btn
          v-if="dadosLote.etapa == 99 && envioAutomatico && dadosLote.fl_tratado!=1 || dadosLote.env_op_tem_erro == 1 && dadosLote.etapa != 20"
          color="primary"
          height="30px"
          small
          depressed
          class="ml-4"
          @click="updateGuias()"
        >
          Editar guia
        </v-btn>
      </v-row>
    <p v-if="itemsErro == null && listEnvio ==null && listLote == null && listGuia == null" class="text-center pt-7 pb-0" style="font-size:14px">
      Não há dados disponíveis 
    </p>
    <IgnoraErroDlg
      :complementar="dadosLote.complementar"
      :dialog="showIgnoraErro"
      :isLoteComplementar="dadosLote.complementar"
      :items="dadosLote"
      :parametros="parametros"
      :sendForm="(formData, acao) => setFlagTratado(formData, acao)"
      :showClose="()=>showIgnoraErro=false"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex"
import moment from "moment"
import IgnoraErroDlg from '@/components/faturamento/dados_cronograma/IgnoraErroDlg'
moment.locale("pt-BR")
export default {
  components: {
    IgnoraErroDlg
  },
  data() {
    return {
      showTable: false,
      showIgnoraErro: false,
      headersGuia: [
        { text: "Código", value: "codigo", sortable: false },
        { text: "Descrição", value: "descricao", sortable: false },
      ],
      headers: [
        { text: "Código", align: "start", value: "ErrorCode", sortable: false },
        { text: "Descrição", value: "ErrorMessage", sortable: false },
      ],
      listEnvio: null,
      listErros: null,
      listLote: null,
      listGuia: null,
      parametros: null,
      type: null
    };
  },
  watch:{
    critica: {
      deep: true,
      handler(){
        this.listLote = null
        this.listGuia = null
        this.listEnvio = null
        if (this.critica  !=null  && (this.critica.erroProtocolo || this.critica.erroGuia )) {
                this.listLote = this.critica.erroProtocolo? this.critica.erroProtocolo.erros.erro : null
                this.listGuia = this.critica.erroGuia? this.critica.erroGuia : null
                this.type = 3
        } else if(this.critica !=null && this.critica.erros){
                this.listEnvio = this.critica.erros.erro
                this.type = this.listEnvio.filter(x=> x.codigo == "9999").length > 0 ? null : 2
        } else {
          
          this.type = null
        }
        this.$nextTick();
      }
    },
    dadosLote: {
      deep: true,
      handler(val){
        if(val && val.cronograma_id){
          this.getParametrizacao();
        }

        }
      }
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  mounted() {
    if (this.critica && (this.critica.erroProtocolo || this.critica.erroGuia )) {
                this.listLote = this.critica.erroProtocolo? this.critica.erroProtocolo.erros.erro : null
                this.listGuia = this.critica.erroGuia? this.critica.erroGuia : null
                console.log("tipo 3")
                this.type = 3
              } else if(this.critica && this.critica.erros){
                console.log("tipo talvez 2")
                this.listEnvio = this.critica.erros.erro
                this.type = this.listEnvio.filter(x=> x.codigo == "9999" ).length > 0 ? null : 2
              } else {
                this.type = this.itemsErro.Erro.filter(x=> ["9999", "2", "31", "32"].includes(x.ErrorCode ) ).length > 0 ? 2 : null
                console.log(this.type)
              }
        this.$nextTick();
    setTimeout(()=>{
      if(this.dadosLote && this.dadosLote.cronograma_id)
          this.getParametrizacao();
    },100)     
    
  },
computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
    }),
  },
  methods: {
    getParametrizacao(){
      let opts = {
            query: [
                {
                Modulo: "Portal",
                Acao: "getparametrizacoes",
                Payload: {
                    grupo_economico: this.grupoEconomico,
                    cronograma_id: this.dadosLote.cronograma_id
                },
                },
            ],
            noLoader: true,
            };
            this.$store.dispatch("request/doRequest", opts).then(resp => this.parametros = resp.parametros)
        },
    ReenvioDeLote(){
        let {cronograma_id, id, prestador_id} = this.dadosLote
        let _this = this
        let obj = {
          query: [
            {
              modulo: "Faturamento",
              acao: "reenviodelote",
              payload: {
                grupo_economico: this.grupoEconomico,
                lote_id: id, 
                cronograma_id,
                prestador_id
              },
            },
          ],
        };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }
            let paramModal = {
                type: "success",
                title: "Sucesso",
                message: response.mensagem,
                callback: ()=> { _this.clean(); _this.close(); _this.updatePage()},
                btConfirm: { name: "Ok", show: true },
                btCancel: { name: "Não", show: false }
              };
              this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          });
     },
    updateGuias() {
      let id = this.dadosLote.id
      let url  = '/faturamento/cronogramas/dadosdocronograma/detalhesdolote/'+id
      this.$router.push(url)
    },
    // setFlagTratadoConfirm() {
    //   let id = this.dadosLote.id
    //   let paramModal = {
    //     title: "Deseja realmente ignorar os erros deste lote?",
    //     message: "",
    //     messageForm: (text) => {
    //         let msg = text
    //         this.setFlagTratado(id, msg)
    //       },
    //     textForm: { label: "Justificativa", show: true },
    //     type: "warning",
    //     btConfirm: { name: "Confirmar", show: true, color:"warning" },
    //     btCancel: { name: 'Cancelar', show: true }
    //   }
    //   this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    // },
    showIgnorarErro(){

    },
    setFlagTratado(payload, acao) {
      let lote_id = this.dadosLote.id
      let prestador_id = this.dadosLote.prestador_id
      let obj = {
        query: [
          {
            Modulo: "Faturamento",
            Acao: acao,
            Payload: {
              grupo_economico: this.$store.state.permissions.grupoEconomico,
              lote_id,
              prestador_id,
              ...payload
            },
          },
        ],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: this.cleanClose,
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        
      })
      
    }
  },
  props: {
    cleanClose: Function,
    critica: Object,
    dadosLote: Object,
    envioAutomatico: Boolean,
    itemsErro: Object,
    noLine: Boolean,
    showType: Number
  },
};
</script>

<style scoped>
button {
  outline: none;
}
div.v-data-table {
  padding: 0 !important
}

</style>